import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";
import Transition from "../../stateless/Transition";
import ProductDistributionForm from "../inventory/forms/ProductDistributionForm";

const DistributionDialog = ({
  title,
  open,
  onClose,
  detailProduct,
  productsIdSelected,
  productType,
  bulkCashCard,
}) => {
  const handleClose = () => onClose();

  return (
    <Dialog
      open={open}
      maxWidth={"md"}
      onClose={handleClose}
      keepMounted
      TransitionComponent={Transition}
      aria-labelledby="simple-dialog-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="simple-dialog-title" style={{ textAlign: "center" }}>
        Distribución de {title}
      </DialogTitle>
      <DialogContent>
        <ProductDistributionForm
          onClose={onClose}
          itemsIdSelected={productsIdSelected}
          detailProduct={detailProduct}
          productType={productType}
          bulkCashCard={bulkCashCard}
        />
      </DialogContent>
    </Dialog>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(DistributionDialog);
